import type { Language } from './index';

type ServiceDataType = {
  features: string[];
  benefits: string[];
};

export const serviceData = {
  'zh-CN': {
    digitalTwin: {
      features: [
        'DMCC官方ISP特权资质',
        '远程视频见证开户',
        '数字化文件递交系统',
        '虚拟办公室与商业地址',
        '全程中文服务支持',
        '7-14个工作日快速设立'
      ],
      benefits: [
        '无需亲赴迪拜，节省差旅成本',
        '合规持有阿联酋商业实体',
        '享受0%企业所得税优惠',
        '开立国际银行账户',
        '全球贸易与投资便利',
        '品牌国际化形象提升'
      ]
    },
    verticalStrategy: {
      features: [
        '游戏出海合规架构设计',
        'RWA资产代币化方案',
        'AI算力镜像主体设立',
        '垂直领域牌照申请',
        '业务模式合规审查',
        '行业资源对接'
      ],
      benefits: [
        '规避政策风险',
        '加速业务出海',
        '获取行业牌照',
        '对接国际资本',
        '建立合规护城河',
        '抢占市场先机'
      ]
    },
    crossDomain: {
      features: [
        'Resolution No.11许可申请',
        '自由区与本土业务打通',
        '本土合作伙伴对接',
        '跨境合规审查',
        '持续合规监控',
        '政府关系维护'
      ],
      benefits: [
        '突破自由区限制',
        '拓展本土市场',
        '降低合规风险',
        '提升运营效率',
        '获取政府支持',
        '建立长期竞争力'
      ]
    }
  },
  'zh-TW': {
    digitalTwin: {
      features: [
        'DMCC官方ISP特權資質',
        '遠程視頻見證開戶',
        '數字化文件遞交系統',
        '虛擬辦公室與商業地址',
        '全程中文服務支持',
        '7-14個工作日快速設立'
      ],
      benefits: [
        '無需親赴杜拜，節省差旅成本',
        '合規持有阿聯酋商業實體',
        '享受0%企業所得稅優惠',
        '開立國際銀行賬戶',
        '全球貿易與投資便利',
        '品牌國際化形象提升'
      ]
    },
    verticalStrategy: {
      features: [
        '遊戲出海合規架構設計',
        'RWA資產代幣化方案',
        'AI算力鏡像主體設立',
        '垂直領域牌照申請',
        '業務模式合規審查',
        '行業資源對接'
      ],
      benefits: [
        '規避政策風險',
        '加速業務出海',
        '獲取行業牌照',
        '對接國際資本',
        '建立合規護城河',
        '搶占市場先機'
      ]
    },
    crossDomain: {
      features: [
        'Resolution No.11許可申請',
        '自由區與本土業務打通',
        '本土合作夥伴對接',
        '跨境合規審查',
        '持續合規監控',
        '政府關係維護'
      ],
      benefits: [
        '突破自由區限制',
        '拓展本土市場',
        '降低合規風險',
        '提升運營效率',
        '獲取政府支持',
        '建立長期競爭力'
      ]
    }
  },
  'en': {
    digitalTwin: {
      features: [
        'Official DMCC ISP Privilege',
        'Remote Video Witness Account Opening',
        'Digital Document Submission System',
        'Virtual Office & Business Address',
        'Full Chinese Language Support',
        '7-14 Working Days Setup'
      ],
      benefits: [
        'No Dubai Travel Required, Save Costs',
        'Compliant UAE Business Entity',
        '0% Corporate Income Tax',
        'International Bank Account',
        'Global Trade & Investment Facilitation',
        'Enhanced International Brand Image'
      ]
    },
    verticalStrategy: {
      features: [
        'Gaming Overseas Compliance Structure',
        'RWA Asset Tokenization Solutions',
        'AI Computing Power Entity Setup',
        'Vertical Domain License Application',
        'Business Model Compliance Review',
        'Industry Resource Connection'
      ],
      benefits: [
        'Avoid Policy Risks',
        'Accelerate Business Expansion',
        'Obtain Industry Licenses',
        'Connect with International Capital',
        'Build Compliance Moat',
        'Seize Market Opportunities'
      ]
    },
    crossDomain: {
      features: [
        'Resolution No.11 License Application',
        'Free Zone & Mainland Business Bridge',
        'Local Partner Connection',
        'Cross-Border Compliance Review',
        'Continuous Compliance Monitoring',
        'Government Relations Maintenance'
      ],
      benefits: [
        'Break Free Zone Restrictions',
        'Expand Mainland Market',
        'Reduce Compliance Risks',
        'Improve Operational Efficiency',
        'Gain Government Support',
        'Build Long-Term Competitiveness'
      ]
    }
  },
  'ja': {
    digitalTwin: {
      features: [
        'DMCC公式ISP特権資格',
        'リモートビデオ立会口座開設',
        'デジタル文書提出システム',
        'バーチャルオフィス＆ビジネスアドレス',
        '全面的な中国語サポート',
        '7-14営業日での迅速設立'
      ],
      benefits: [
        'ドバイ渡航不要、出張コスト削減',
        'UAE商業エンティティの合法的保有',
        '0%法人所得税の享受',
        '国際銀行口座開設',
        'グローバル貿易・投資の利便性',
        'ブランドの国際化イメージ向上'
      ]
    },
    verticalStrategy: {
      features: [
        'ゲーム海外展開コンプライアンス構造',
        'RWA資産トークン化ソリューション',
        'AI計算能力ミラーエンティティ設立',
        '垂直領域ライセンス申請',
        'ビジネスモデルコンプライアンスレビュー',
        '業界リソース接続'
      ],
      benefits: [
        '政策リスクの回避',
        'ビジネス海外展開の加速',
        '業界ライセンスの取得',
        '国際資本との接続',
        'コンプライアンスの堀の構築',
        '市場機会の先取り'
      ]
    },
    crossDomain: {
      features: [
        'Resolution No.11ライセンス申請',
        'フリーゾーン・本土ビジネスの橋渡し',
        '現地パートナー接続',
        '国境を越えたコンプライアンスレビュー',
        '継続的コンプライアンス監視',
        '政府関係維持'
      ],
      benefits: [
        'フリーゾーン制限の突破',
        '本土市場の拡大',
        'コンプライアンスリスクの低減',
        '運営効率の向上',
        '政府支援の獲得',
        '長期的競争力の構築'
      ]
    }
  },
  'ko': {
    digitalTwin: {
      features: [
        'DMCC 공식 ISP 특권 자격',
        '원격 비디오 증인 계좌 개설',
        '디지털 문서 제출 시스템',
        '가상 사무실 및 비즈니스 주소',
        '전체 중국어 서비스 지원',
        '7-14 영업일 신속 설립'
      ],
      benefits: [
        '두바이 방문 불필요, 출장 비용 절감',
        'UAE 비즈니스 엔티티 합법적 보유',
        '0% 법인 소득세 혜택',
        '국제 은행 계좌 개설',
        '글로벌 무역 및 투자 편의',
        '브랜드 국제화 이미지 향상'
      ]
    },
    verticalStrategy: {
      features: [
        '게임 해외 진출 규정 준수 구조',
        'RWA 자산 토큰화 솔루션',
        'AI 컴퓨팅 파워 미러 엔티티 설립',
        '수직 영역 라이선스 신청',
        '비즈니스 모델 규정 준수 검토',
        '업계 리소스 연결'
      ],
      benefits: [
        '정책 위험 회피',
        '비즈니스 해외 진출 가속화',
        '업계 라이선스 획득',
        '국제 자본 연결',
        '규정 준수 해자 구축',
        '시장 기회 선점'
      ]
    },
    crossDomain: {
      features: [
        'Resolution No.11 라이선스 신청',
        '자유 구역 및 본토 비즈니스 연결',
        '현지 파트너 연결',
        '국경 간 규정 준수 검토',
        '지속적인 규정 준수 모니터링',
        '정부 관계 유지'
      ],
      benefits: [
        '자유 구역 제한 돌파',
        '본토 시장 확장',
        '규정 준수 위험 감소',
        '운영 효율성 향상',
        '정부 지원 획득',
        '장기 경쟁력 구축'
      ]
    }
  }
} as const;

export function getServiceData(language: Language, serviceId: 'digitalTwin' | 'verticalStrategy' | 'crossDomain'): ServiceDataType {
  const data = serviceData[language][serviceId];
  return {
    features: [...data.features],
    benefits: [...data.benefits]
  };
}
